import React from 'react';
import { 
  TopNavigation
} from '@amzn/awsui-components-console';
import { useNavigate } from 'react-router-dom';
import AmazonLogo from '../../images/amazon-logo.svg';
import './Header.scss';

interface HeaderProps {
  userName?: string;
  displayName?: string;
  applicationName?: string;
  onSignOut?: () => void;
  onUserMenuClick?: (event: any) => void;
}

const Header: React.FC<HeaderProps> = ({ 
  userName = '', 
  displayName = '',
  applicationName = 'ADDAPT',
  onSignOut,
  onUserMenuClick
}) => {
  const navigate = useNavigate();
  const [signOutTriggered, setSignOutTriggered] = React.useState(false);

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleUserMenuClick = async (event: any) => {
    const { id } = event.detail;
    
    if (id === 'signout') {
      setSignOutTriggered(true);
      if (onSignOut) {
        await onSignOut();
      }
      setSignOutTriggered(false);
    } else if (onUserMenuClick) {
      onUserMenuClick(event);
    }
  };

  return (
    <header id="header" className="addapt-header">
      <TopNavigation
        identity={{
          href: "#",
          title: applicationName,
          logo: {
            src: AmazonLogo,
            alt: "Amazon"
          },
          onFollow: (event) => {
            event.preventDefault();
            handleLogoClick();
          }
        }}
        utilities={[
          {
            type: "menu-dropdown",
            text: "Get Support",
            items: [
              {
                id: "user-guide",
                text: "User Guide",
                href: "https://w.amazon.com/bin/view/FinTech/ADDAPT/",
                external: true,
                externalIconAriaLabel: " (opens in a new tab)"
              },
              {
                id: "report-bug",
                text: "Report a Bug",
                href: "https://t.corp.amazon.com/create/templates/3eefec3e-c800-457c-89e1-69cd70100ce8",
                external: true,
                externalIconAriaLabel: " (opens in a new tab)"
              },
              {
                id: "onboard-dataset",
                text: "Onboard Dataset",
                href: "https://t.corp.amazon.com/create/templates/295d8e60-7294-4036-91e5-841f93e3322d",
                external: true,
                externalIconAriaLabel: " (opens in a new tab)"
              },
              {
                id: "request-feature",
                text: "Request a Feature",
                href: "https://sim.amazon.com/issues/create?template=6963e414-89b2-416d-aa8d-9e15952b2637",
                external: true,
                externalIconAriaLabel: " (opens in a new tab)"
              },
              {
                id: "slack-channel",
                text: "Slack Channel",
                href: "https://amazon.enterprise.slack.com/archives/C0ARAR2E5F1",
                external: true,
                externalIconAriaLabel: " (opens in a new tab)"
              }
            ]
          },
          {
            type: "button",
            iconName: "notification",
            title: "Notifications",
            ariaLabel: "Notifications (0 unread)",
            badge: false,
            onClick: () => {
              {}
            }
          },
          {
            type: "button",
            iconName: "settings",
            title: "Settings",
            ariaLabel: "Settings",
            onClick: () => {
              {}
            }
          },
          {
            type: "menu-dropdown",
            iconName: "user-profile",
            text: displayName || userName,
            description: userName,
            onItemClick: handleUserMenuClick,
            items: [
            
              {
                id: "signout",
                text: "Sign out",
                iconName: "undo"
              }
            ]
          }
        ]}
      />
    </header>
  );
};

export default Header;
